export default __webpack_public_path__ + "static/media/drawing-woman14-focusfill.c8988b39.svg";